import type { TFunction } from 'i18next';
import type { FilterFieldOption } from '~/components/ui';
import {
  COMPARISON_FILTER_FIELD,
  newComparisonFilterRowId,
  type ComparisonFilterRow,
} from '~/pages/order-builder/lib/comparisonFilters';

type T = TFunction<'order-builder'>;

export const DEFAULT_COMPARISON_FILTER_ROW: Omit<ComparisonFilterRow, 'id'> = {
  field: COMPARISON_FILTER_FIELD.sellerName,
  operator: 'contains',
  value: '',
  connector: 'and',
};

const textOperators = (t: T): FilterFieldOption['operatorOptions'] => [
  { label: t('order_builder.filter.operators.contains'), operator: 'contains' },
  { label: t('order_builder.filter.operators.is'), operator: 'eq' },
  { label: t('order_builder.filter.operators.is_not'), operator: 'neq' },
  {
    label: t('order_builder.filter.operators.does_not_contain'),
    operator: 'notContain',
  },
];

export function getComparisonFilterFields(t: T): FilterFieldOption[] {
  return [
    {
      field: COMPARISON_FILTER_FIELD.sellerName,
      label: t('order_builder.filter.fields.seller_name'),
      operatorOptions: textOperators(t),
      inputType: 'string',
    },
  ];
}

export function newComparisonFilterRow(): ComparisonFilterRow {
  return { ...DEFAULT_COMPARISON_FILTER_ROW, id: newComparisonFilterRowId() };
}
